import { Routes } from '@angular/router';
import { GermplasmDetailsComponent } from './germplasm-details.component';
import { BasicDetailsPaneComponent } from './basic-details/basic-details-pane.component';
import { AttributesPaneComponent } from './attributes/attributes-pane.component';
import { PedigreePaneComponent } from './pedigree/pedigree-pane.component';
import { ObservationsPaneComponent } from './observations/observations-pane.component';
import { InventoryPaneComponent } from './inventory/inventory-pane.component';
import { ListsPaneComponent } from './lists/lists-pane.component';
import { SamplesPaneComponent } from './samples/samples-pane.component';
import { GermplasmDetailsPopupComponent } from './germplasm-details-modal.component';
import { RouteAccessService } from '../shared';
import { GermplasmDetailsGraphvizModalPopupComponent } from './germplasm-details-graphviz-modal.component';
import { FilesPaneComponent } from './files/files-pane.component';
import { GenotypingPaneComponent } from './genotyping/genotyping-pane.component';
import { GermplasmDetailsMainComponent } from './germplasm-details-main.component';
import { germplasmGidResolver } from './germplasm-gid.resolver';

export const GERMPLASM_DETAILS_ROUTES: Routes = [
    {
        // Path for showing germplasm details as a standalone page in an internet browser.
        path: 'germplasm-details/:gid',
        resolve: { gid: germplasmGidResolver },
        component: GermplasmDetailsComponent,
        data: {
            authorities: [],
            pageTitle: 'germplasm-details.tab.title'
        },
        canActivate: [RouteAccessService],
        children: [
            {
                path: '',
                redirectTo: 'germplasm-basic-details',
                pathMatch: 'full'
            },
            {
                path: 'germplasm-basic-details',
                component: BasicDetailsPaneComponent,
                data: {
                    authorities: [],
                    pageTitle: 'germplasm-details.tab.title'
                }
            },
            {
                path: 'attributes',
                component: AttributesPaneComponent,
                data: {
                    authorities: [],
                    pageTitle: 'germplasm-details.tab.title'
                }
            },
            {
                path: 'pedigree',
                component: PedigreePaneComponent,
                data: {
                    authorities: [],
                    pageTitle: 'germplasm-details.tab.title'
                }
            },
            {
                path: 'observations',
                component: ObservationsPaneComponent,
                data: {
                    authorities: [],
                    pageTitle: 'germplasm-details.tab.title'
                }
            },
            {
                path: 'inventory',
                component: InventoryPaneComponent,
                data: {
                    authorities: [],
                    pageTitle: 'germplasm-details.tab.title'
                }
            },
            {
                path: 'lists',
                component: ListsPaneComponent,
                data: {
                    authorities: [],
                    pageTitle: 'germplasm-details.tab.title'
                }
            },
            {
                path: 'samples',
                component: SamplesPaneComponent,
                data: {
                    authorities: [],
                    pageTitle: 'germplasm-details.tab.title'
                }
            },
            {
                path: 'files',
                component: FilesPaneComponent,
                data: {
                    authorities: [],
                    pageTitle: 'germplasm-details.tab.title'
                }
            },
            {
                path: 'genotyping',
                component: GenotypingPaneComponent,
                data: {
                    authorities: [],
                    pageTitle: 'germplasm-details.tab.title'
                }
            }
        ]
    },
    {
        // Path for showing germplasm details as a dialog box in Angular.
        path: 'germplasm-details-dialog/:gid',
        component: GermplasmDetailsPopupComponent,
        outlet: 'popup'
    },
    {
        path: 'germplasm-details/graphviz/:gid',
        component: GermplasmDetailsGraphvizModalPopupComponent,
        outlet: 'popup'
    },
    {
        path: 'germplasm-details-main/:gid',
        component: GermplasmDetailsMainComponent,
        outlet: 'germplasmDetailsPopup',
        children: [
            {
                path: 'germplasm-basic-details',
                component: BasicDetailsPaneComponent,
                outlet: 'modalContent'
            },
            {
                path: 'attributes',
                component: AttributesPaneComponent,
                outlet: 'modalContent'
            },
            {
                path: 'pedigree',
                component: PedigreePaneComponent,
                outlet: 'modalContent'
            },
            {
                path: 'observations',
                component: ObservationsPaneComponent,
                outlet: 'modalContent'
            },
            {
                path: 'inventory',
                component: InventoryPaneComponent,
                outlet: 'modalContent'
            },
            {
                path: 'lists',
                component: ListsPaneComponent,
                outlet: 'modalContent'
            },
            {
                path: 'samples',
                component: SamplesPaneComponent,
                outlet: 'modalContent'
            },
            {
                path: 'files',
                component: FilesPaneComponent,
                outlet: 'modalContent'
            },
            {
                path: 'genotyping',
                component: GenotypingPaneComponent,
                outlet: 'modalContent'
            }
        ]
    }
];
